require("./control_create_clone_of_menu.js");
require("./control_create_clone_of.js");
require("./control_delete_this_clone.js");
require("./control_elapsed.js");
require("./control_forever.js");
require("./control_if_else.js");
require("./control_if.js");
require("./control_isclone.js");
require("./control_repeat_until.js");
require("./control_repeat.js");
require("./control_start_as_clone.js");
require("./control_stop.js");
require("./control_wait_until.js");
require("./control_wait.js");
require("./control_while.js");
